<template>
    <a-skeleton active :loading="loading">
        <section v-if="expert.auditState==='1' || expert.auditState==='0'">
            <detail/>
        </section>
        <section v-else>
            <audit/>
        </section>
    </a-skeleton>
</template>

<script>
import {expert} from "@/api/projectReviewService";
import Audit from "@/views/sys/expert/expertAudit/components/Audit.vue";
import Detail from "@/views/sys/expert/expertAudit/components/Detail.vue";
export default {
    name: "index",
    components: {Audit,Detail},

    data() {
        return {
            view:'Audit',
            expert: {},
            loading:true
        }
    },
    mounted() {
        this.getExpertInfo()
    },
    methods: {
        getExpertInfo() {
            this.loading = true
            this.getAction({
                url: expert.current
            }).then(res => {
                // res.professionDomain = res.professionDomain.split(",")
                this.expert = {...res}
                this.loading = false
            })
        },
    }
}
</script>

<style scoped lang="less">

</style>
